(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["depict-patched-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gifts-by-price"] && !Shopify.designMode) return;
  try {
    
(function () {
  const navLinks = document.querySelectorAll('.gbp-sticky-nav__link');
  const tiers = document.querySelectorAll('.gbp-tier');
  const nav = document.getElementById('gbp-nav');

  if (!navLinks.length || !tiers.length) return;

  // Smooth scroll with offset for sticky header + nav
  navLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.getElementById(this.getAttribute('href').slice(1));
      if (!target) return;
      const navH = nav ? nav.offsetHeight : 0;
      const headerH = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0'
      );
      const top = target.getBoundingClientRect().top + window.scrollY - navH - headerH - 12;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

  // Highlight active tier in nav on scroll
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          navLinks.forEach(l => l.classList.remove('is-active'));
          const active = document.querySelector(
            `.gbp-sticky-nav__link[data-tier="${entry.target.id}"]`
          );
          if (active) {
            active.classList.add('is-active');
            active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        }
      });
    },
    { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
  );

  tiers.forEach(tier => observer.observe(tier));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customer-order"]) return;
  try {
    
  (function () {
    var orderPanel     = document.querySelector('.myaccount__panel');
    var fitPanel       = document.getElementById('fit-review-panel');
    var backBtn        = document.getElementById('fit-review-back');
    var activeLineItem = null; // tracks which line item triggered the panel


    function showFitReview(btn) {
      activeLineItem = btn.closest('.order-line-item-wrap');
      var img          = document.getElementById('fit-review-image');
      var title        = document.getElementById('fit-review-title');
      var variant      = document.getElementById('fit-review-variant');
      var qty          = document.getElementById('fit-review-qty');
      var tracking     = document.getElementById('fit-review-tracking');
      var hiddenId     = document.getElementById('fit-review-hidden-id');
      var hiddenTitle  = document.getElementById('fit-review-product-title-hidden');

      img.src               = btn.dataset.image || '';
      img.alt               = btn.dataset.title || '';
      title.textContent     = btn.dataset.title   || '';
      variant.textContent   = btn.dataset.variant || '';
      qty.textContent       = 'Qty: ' + (btn.dataset.qty || '1');
      hiddenId.value        = btn.dataset.lineItemId || '';
      hiddenTitle.value     = btn.dataset.title || '';

      var trackingNum     = btn.dataset.trackingNumber;
      var trackingCompany = btn.dataset.trackingCompany;
      if (trackingNum) {
        tracking.textContent = 'Tracking: ' + (trackingCompany ? trackingCompany + ' - ' : '') + trackingNum;
        tracking.style.display = '';
      } else {
        tracking.style.display = 'none';
      }

      // reset form state
      document.getElementById('fit-review-description').value = '';
      document.getElementById('fit-review-error').style.display = 'none';
      document.querySelectorAll('.fit-review__file-input').forEach(function(i) {
        i.value = '';
        var lbl = i.closest('.fit-review__upload-btn').querySelector('.fit-review__upload-label');
        lbl.textContent = 'Upload file';
        lbl.classList.remove('has-file');
      });

      orderPanel.hidden = true;
      fitPanel.hidden   = false;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function showOrder() {
      fitPanel.hidden   = true;
      orderPanel.hidden = false;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // bind Change My Fit buttons
    document.querySelectorAll('.js-change-fit').forEach(function (btn) {
      btn.addEventListener('click', function () { showFitReview(btn); });
    });

    // back button
    if (backBtn) backBtn.addEventListener('click', showOrder);

    // show file name on selection
    document.querySelectorAll('.fit-review__file-input').forEach(function (input) {
      input.addEventListener('change', function () {
        var label = input.closest('.fit-review__upload-btn').querySelector('.fit-review__upload-label');
        if (input.files && input.files[0]) {
          label.textContent = input.files[0].name;
          label.classList.add('has-file');
        } else {
          label.textContent = 'Upload file';
          label.classList.remove('has-file');
        }
      });
    });

    var API = 'https://sene-fit-reviews-api.vercel.app';

    // Compress an image file to JPEG at max 1600px / 82% quality so it stays under Vercel's 4.5MB limit
    function compressImage(file) {
      return new Promise(function(resolve) {
        if (!file.type.startsWith('image/')) { resolve(file); return; }
        var img = new Image();
        var url = URL.createObjectURL(file);
        img.onload = function() {
          URL.revokeObjectURL(url);
          var MAX = 1600;
          var w = img.width, h = img.height;
          if (w > MAX || h > MAX) {
            if (w >= h) { h = Math.round(h * MAX / w); w = MAX; }
            else        { w = Math.round(w * MAX / h); h = MAX; }
          }
          var canvas = document.createElement('canvas');
          canvas.width = w; canvas.height = h;
          canvas.getContext('2d').drawImage(img, 0, 0, w, h);
          canvas.toBlob(function(blob) {
            resolve(new File([blob], file.name.replace(/\.[^.]+$/, '.jpg'), { type: 'image/jpeg' }));
          }, 'image/jpeg', 0.82);
        };
        img.onerror = function() { URL.revokeObjectURL(url); resolve(file); };
        img.src = url;
      });
    }

    // Convert a File/Blob to a base64 string (no data: prefix)
    function fileToBase64(file) {
      return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function(e) {
          var b64 = e.target.result.split(',')[1];
          resolve(b64);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    }

    function uploadFileToDrive(file, meta) {
      // Compress images first, then send base64 through Vercel → Drive
      return compressImage(file).then(function(compressed) {
        return fileToBase64(compressed).then(function(b64) {
          return fetch(API + '/api/upload-file', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              customerId:   meta.customerId,
              customerFirst: meta.customerFirst,
              customerLast:  meta.customerLast,
              orderId:      meta.orderId,
              orderNumber:  meta.orderNumber,
              lineItemId:    meta.lineItemId,
              productTitle:  meta.productTitle,
              fileName: compressed.name,
              mimeType: compressed.type,
              fileData: b64,
            }),
          })
          .then(function(r) { return r.json(); })
          .then(function(data) {
            if (!data.viewLink) throw new Error('Upload failed: ' + (data.error || 'unknown'));
            return data.viewLink;
          });
        });
      });
    }

    // submit handler
    var submitBtn = document.getElementById('fit-review-submit');
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        var errorEl     = document.getElementById('fit-review-error');
        errorEl.style.display = 'none';

        var description = document.getElementById('fit-review-description').value.trim();
        if (!description) {
          errorEl.textContent = 'Please describe the fit issues before submitting.';
          errorEl.style.display = 'block';
          return;
        }

        var frontFile = document.getElementById('fit-file-front').files[0] || null;
        var sideFile  = document.getElementById('fit-file-side').files[0]  || null;
        var backFile  = document.getElementById('fit-file-back').files[0]  || null;
        if (!frontFile || !sideFile || !backFile) {
          errorEl.textContent = 'Please upload a front, side, and back photo before submitting.';
          errorEl.style.display = 'block';
          return;
        }

        var orderNumber   = document.getElementById('fit-review-order-number').value;
        var orderId       = document.getElementById('fit-review-order-id').value;
        var customerId    = document.getElementById('fit-review-customer-id').value;
        var customerFirst = document.getElementById('fit-review-customer-first').value;
        var customerLast  = document.getElementById('fit-review-customer-last').value;
        var customerEmail = document.getElementById('fit-review-customer-email').value;
        var productTitle  = document.getElementById('fit-review-product-title-hidden').value;
        var lineItemId    = document.getElementById('fit-review-hidden-id').value;

        var videoFile = document.getElementById('fit-file-video').files[0] || null;

        submitBtn.textContent = 'Uploading…';
        submitBtn.disabled = true;

        var uploadMeta = { customerId: customerId, customerFirst: customerFirst, customerLast: customerLast, orderId: orderId, orderNumber: orderNumber, lineItemId: lineItemId, productTitle: productTitle };
        var uploads = [
          frontFile ? uploadFileToDrive(frontFile, uploadMeta) : Promise.resolve(null),
          sideFile  ? uploadFileToDrive(sideFile,  uploadMeta) : Promise.resolve(null),
          backFile  ? uploadFileToDrive(backFile,  uploadMeta) : Promise.resolve(null),
          videoFile ? uploadFileToDrive(videoFile, uploadMeta) : Promise.resolve(null),
        ];

        Promise.all(uploads)
        .then(function(links) {
          submitBtn.textContent = 'Sending…';
          return fetch(API + '/api/send-fit-email', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              orderNumber:    orderNumber,
              customerFirst:  customerFirst,
              customerLast:   customerLast,
              customerEmail:  customerEmail,
              productTitle:   productTitle,
              description:    description,
              frontPhotoLink: links[0],
              sidePhotoLink:  links[1],
              backPhotoLink:  links[2],
              videoLink:      links[3],
            })
          });
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.success) {
            // Write to Shopify order metafield so badge persists on refresh
            fetch(API + '/api/mark-fit-review', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ orderId: orderId, lineItemId: lineItemId }),
            });
            // Update DOM immediately without waiting for metafield call
            if (activeLineItem) {
              var badge = activeLineItem.querySelector('.order-badge');
              if (badge) {
                badge.textContent = 'Fit Review';
                badge.className = 'order-badge order-badge--fit-review';
              }
              var actions = activeLineItem.querySelector('.order-item__actions');
              if (actions) actions.remove();
            }
            fitPanel.hidden   = true;
            orderPanel.hidden = false;
            window.scrollTo({ top: 0, behavior: 'smooth' });
          } else {
            throw new Error(data.error || 'Unknown error');
          }
        })
        .catch(function(err) {
          console.error(err);
          submitBtn.textContent = 'Submit Now';
          submitBtn.disabled = false;
          errorEl.textContent = 'Something went wrong. Please try again or email support@senestudio.com.';
          errorEl.style.display = 'block';
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
